<template>
  <div class="flex h-full flex-col overflow-hidden bg-light-linen">
    <div class="relative">
      <img
        alt="Beautiful pasta dish"
        class="h-auto max-h-64 w-full object-cover"
        loading="lazy"
        src="https://cdn.shopify.com/s/files/1/1725/5449/files/ab6edda266dc1603de3c3ffa98ff13a5_1_1.webp?v=1714649033"
      />
    </div>
    <div class="bg-light-linen px-8 py-6">
      <h2 class="mb-6 font-brand text-3xl font-light text-terracota">Beautiful pasta awaits...</h2>
      <ul class="space-y-4 text-off-black">
        <li class="flex items-center">
          <div class="mr-4 flex size-10 shrink-0 items-center justify-center rounded-full bg-linen">
            <HowItWorksIcon icon="check" class="size-8 text-terracota-muted" />
          </div>
          <span class="text-base text-off-black">Order a one-off recipe kit or subscribe.</span>
        </li>
        <li class="flex items-center">
          <div class="mr-4 flex size-10 shrink-0 items-center justify-center rounded-full bg-linen">
            <HowItWorksIcon icon="calendar" class="size-6 text-terracota-muted" />
          </div>
          <span class="text-base text-off-black">
            Subscribers can skip, pause or cancel anytime, and can hand pick dishes each week.
          </span>
        </li>
        <li class="flex items-center">
          <div class="mr-4 flex size-10 shrink-0 items-center justify-center rounded-full bg-linen">
            <HowItWorksIcon icon="snowflake" class="size-8 text-terracota-muted" />
          </div>
          <span class="text-base text-off-black">Freeze dishes for up to 1 month.</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script lang="ts" setup>
  defineEmits<{ (e: 'close'): void }>();
</script>
